import GoogleTracking from "./googleTracking";
import AmplitudeTracking from "./amplitudeTracking";
import TRACKING_EVENTS from "./trackingEvents";
import { IS_PROD } from "../const";

class Tracking {
    constructor() {
        this.trackers = {
            google: new GoogleTracking(),
            amplitude: new AmplitudeTracking()
        };
    }

    // Init all tracking services
    init() {
        if (!IS_PROD) return;

        Object.values(this.trackers).forEach((tracker) => {
            tracker.initialize();
        });
    }

    // Common method for tracking events
    dispatchTrackingEvent(eventName, eventData = {}) {
        Object.values(this.trackers).forEach((tracker) => {
            if (tracker.isEnabled) {
                tracker.trackEvent(eventName, eventData);
            }
        });
    }

    // Format Data before send to event listner
    formatParsedData(data = {}, user) {
        // set URL to tracking data
        data = { ...data, url: window.location.href };

        // Bind logged user details
        if (Boolean(user)) {
            data.user = {
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                username: user.username
            };
        }

        // Bind Video information
        if (Boolean(data.video)) {
            data.video = {
                id: data.video.id,
                embedId: data.video.embedId,
                title: data.video.title,
                videoType: data.video.videoType
            };
        }

        // Bind Collection information
        if (Boolean(data.collection)) {
            data.collection = {
                id: data.collection.id,
                name: data.collection.name
            };
        }

        // Bind Module information
        if (Boolean(data.module)) {
            data.module = {
                id: data.module.id,
                name: data.module.name
            };
        }

        return data;
    }

    // Common method for tracking page views
    trackPageView(pagePath, data = {}, user = undefined) {
        const parsedData = this.formatParsedData(data, user);
        this.dispatchTrackingEvent(TRACKING_EVENTS.PAGE_VIEW, {
            ...parsedData,
            page_path: pagePath
        });
    }

    // Track Events
    trackEvent(event, data = {}, user = undefined) {
        if (event === TRACKING_EVENTS.BUTTON_CLICK) {
            data.event_category = "Button";
        }
        const parsedData = this.formatParsedData(data, user);
        this.dispatchTrackingEvent(event, parsedData);
    }
}

const trackingInstance = new Tracking();
export default trackingInstance;
